const parseSseEvent = (eventBlock) => {
  const dataLines = eventBlock
    .split(/\r?\n/)
    .filter((line) => line.startsWith('data:'));

  if (dataLines.length === 0) return null;

  const payload = dataLines
    .map((line) => line.slice(5).replace(/^ /, ''))
    .join('\n')
    .trim();

  if (!payload) return null;
  if (payload === '[DONE]') return '[DONE]';

  return JSON.parse(payload);
};

export const consumeSseResponse = async (response, onEvent) => {
  if (!response?.body) {
    throw new Error('Response stream is unavailable.');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder('utf-8');
  let buffer = '';

  while (true) {
    const { value, done } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });

    const blocks = buffer.split(/\r?\n\r?\n/);
    buffer = blocks.pop() || '';

    for (const block of blocks) {
      const parsed = parseSseEvent(block);
      if (!parsed) continue;
      if (parsed === '[DONE]') {
        if (typeof reader.cancel === 'function') {
          await reader.cancel().catch(() => {});
        }
        return;
      }
      if ((await onEvent(parsed)) === false) {
        if (typeof reader.cancel === 'function') {
          await reader.cancel().catch(() => {});
        }
        return;
      }
    }

    if (done) break;
  }

  if (buffer.trim()) {
    const parsed = parseSseEvent(buffer);
    if (parsed && parsed !== '[DONE]') {
      await onEvent(parsed);
    }
  }
};

export { parseSseEvent };
